import { useState } from "react"
import { get } from "../../api/api"
import SeoIntelligencePanel from "../../components/SeoIntelligencePanel"
import { scoreTone } from "../../utils/seo"

export default function SiteAudit() {
  const [domain, setDomain] = useState("")
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const runAudit = async () => {
    if (!domain) return
    setLoading(true)
    setError("")

    try {
      const res = await get("/seo/full", { params: { domain } })
      setData(res.data)
    } catch (err) {
      setError(err.response?.data?.error || "Audit failed")
    } finally {
      setLoading(false)
    }
  }

  const insights = data?.insights || {}

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Site Audit</h1>
          <p className="muted">Run a bounded crawl and save a full SEO report.</p>
        </div>
      </div>

      <div className="card form-row">
        <label>
          Domain
          <input
            placeholder="example.com"
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
          />
        </label>
        <button onClick={runAudit} disabled={loading}>
          {loading ? "Running..." : "Run audit"}
        </button>
      </div>

      {error && <p className="error">{error}</p>}

      {data && (
        <>
          <div className="grid">
            <div className="card">
              <p className="muted">Domain</p>
              <strong>{data.domain}</strong>
            </div>
            <div className="card">
              <p className="muted">Pages crawled</p>
              <div className="metric">{data.pages}</div>
            </div>
            <div className="card">
              <p className="muted">Score</p>
              <div className={`score-ring small ${scoreTone(data.score)}`} style={{ "--score": data.score }}>
                {data.score}
              </div>
            </div>
          </div>

          <SeoIntelligencePanel domain={data.domain} score={data.score} insights={insights} />
        </>
      )}
    </div>
  )
}
